var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nf-button",style:({ width: _vm.width })},[_c('div',{staticClass:"nf-button_box"},[_c('div',{staticClass:"nf-button_box_solid",class:{ 'nf-button_box_disabled': _vm.disabled },style:({
        padding: _vm.padding,
        'border-radius': _vm.round,
        'border-width': _vm.borderSize,
        'font-size': _vm.fontSize,
        backgroundColor: _vm.color,
        color: _vm.fontColor,
      })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }